const Config = {
  redirectUri: "https://sidearmvoting.com/login",
  redirectUriSignout: "https://sidearmvoting.com/logout",
  apiUrlBase: "https://api.sidearmvoting.com",
}

export default Config